import { getSearchParamValues } from "./getParamValues";
import { mapToDom } from "./mapToDom";
const init = (args) => {
    const params = getSearchParamValues();
    mapToDom(params);
    if (args.onSuccess) {
        args.onSuccess();
    }
};
window.VSCOCaptured = {
    init,
};
export default init;
